import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowLeft, Home } from "lucide-react";
import { companyInfo } from "../data/mock";

export default function NotFoundPage() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4" style={{ backgroundColor: "var(--warm-bg)" }}>
      <div className="max-w-lg w-full text-center py-20">
        <div className="text-8xl font-bold mb-4" style={{ color: "var(--gold)", fontFamily: "'Playfair Display', serif", opacity: 0.3 }}>
          404
        </div>
        <h1 className="text-2xl sm:text-3xl font-semibold mb-4" style={{ fontFamily: "'Playfair Display', serif", color: "var(--black)" }}>
          Pagina nu a fost găsită
        </h1>
        <p className="mb-10 text-sm leading-relaxed" style={{ color: "var(--text-secondary)" }}>
          Pagina pe care o căutați nu există sau a fost mutată. Vă rugăm să reveniți la pagina principală sau să ne contactați direct.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold no-underline transition-all"
            style={{ backgroundColor: "var(--gold)", color: "var(--black)", borderRadius: "var(--radius-pill)" }}
            data-testid="not-found-home-btn"
          >
            <Home className="w-4 h-4" />
            Înapoi Acasă
          </Link>
          <a
            href={`tel:${companyInfo.phone}`}
            className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold no-underline transition-all"
            style={{ border: "1.5px solid var(--gold)", color: "var(--gold)", borderRadius: "var(--radius-pill)" }}
            data-testid="not-found-call-btn"
          >
            <Phone className="w-4 h-4" />
            {companyInfo.phone}
          </a>
        </div>
      </div>
    </div>
  );
}
